const checkFreeShipping = (amount, shipTotal) => {
  if (Number(shipTotal) > 0) return null;
  const total = Number(amount);
  return total >= process.env.GATSBY_FREE_SHIPPING_THRESHOLD;
};
export default checkFreeShipping;
